import type { AddedProcess } from '@/mocks/customizationMenu';
import type { ConfirmedSelection } from '@/pages/customize-quote/types';

export interface StoredProcessResult {
  imageUrl: string;
  title: string;
  imageType: string;
  selections: ConfirmedSelection[];
}

interface CustomizeQuoteSnapshot {
  locationKey: string;
  addedProcesses: AddedProcess[];
  confirmedData: Record<string, unknown>;
  results: Record<string, StoredProcessResult>;
}

let snapshot: CustomizeQuoteSnapshot = {
  locationKey: '',
  addedProcesses: [],
  confirmedData: {},
  results: {},
};

export function getSnapshot(): CustomizeQuoteSnapshot {
  return snapshot;
}

export function resetSnapshot(locationKey: string): void {
  snapshot = { locationKey, addedProcesses: [], confirmedData: {}, results: {} };
}

export function savePageState(
  locationKey: string,
  addedProcesses: AddedProcess[],
  confirmedData: Record<string, unknown>,
): void {
  snapshot.locationKey = locationKey;
  snapshot.addedProcesses = addedProcesses;
  snapshot.confirmedData = confirmedData;
}

export function saveProcessResult(processId: string, result: StoredProcessResult): void {
  snapshot.results[processId] = result;
}

export function getProcessResult(processId: string): StoredProcessResult | null {
  return snapshot.results[processId] || null;
}

export function clearSnapshot(): void {
  snapshot = { locationKey: '', addedProcesses: [], confirmedData: {}, results: {} };
}